// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"446":"16f11a6e","452":"16f11a6e","453":"1bb7b6fe","968":"eb8feeb9"}[chunkId] + ".css";
};